import { faCheck, faKey, faPlus } from "@fortawesome/free-solid-svg-icons";
import { faCamera } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import "./Index.css"
import ModalEmailConfirm from './ModalContactConfirm';
import ModalPasswordChange from './ModalPasswordChange';
import SelectSearchV2 from "../../../components/ui/SelectSearchV2";
import { useDispatch, useSelector } from "react-redux";
import { loadUserParameter, loadAuthExternal } from '../../../reducers/models/setting'
import axios from "axios";
import BlockMainAvatar from "./BlockMainAvatar";
import AvatarRound from "../../../components/AvatarRound";
import logo_vk from '../../../files/system/VK_Logo_White.svg';
import logo_ya from '../../../files/system/Ya_Logo.svg';
import BlockProviderModalRemove from "./BlockProviderModalRemove";
import CardName from "../../../components/global/CardName";
import ButtonAction from "../../../components/global/ButtonAction";
import ButtonLight from "../../../components/global/ButtonLight";
import ErrorAdd from "../../../util/ErrorAdd";

function BlockMain() {

    const dispatch = useDispatch()

    const stateSetting = useSelector((state) => state.setting);//Настройки

    //ПЕРЕМЕННЫЕ
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [avatar, setAvatar] = useState(null);

    const [existEmail, setExistEmail] = useState(true);
    const [existPhone, setExistPhone] = useState(true);
    const [passwordShow, setPasswordShow] = useState(true);

    const [contactTypeSelected, setContactTypeSelected] = useState(null);

    const [logFile, setLogFile] = useState(null);


    const [timeZoneList, setTimeZoneList] = useState(null);
    const [timeZoneSelected, setTimeZoneSelected] = useState(null);
    const [timeZoneLoading, setTimeZoneLoading] = useState(false);

    useEffect(() => {
        axios.get('/api_main/database/timeZoneList')
            .then((res) => {
                if (res.data.Status === 1) {
                    setTimeZoneList(res.data.Data.map(t => { return { value: t.Msk, label: t.Full_Name } }));
                }
            })
            .catch((err) => {
                ErrorAdd(err, window.location.href);
            });


        //Список параметров пользователя
        axios.get('/api_main/user/parameterList')
            .then((res) => {
                if (res.data.Status === 1) {
                    dispatch(loadUserParameter({ data: res.data.Data }));
                }
            })
            .catch((err) => {
                ErrorAdd(err, window.location.href);
            });

        //Внешние поставщики авторизации
        loadAuthExternalList();

        //Данные для перехода к внешнему поставщику
        axios.post('/api_main/user/authPkceGenerate', { Redirect: process.env.REACT_APP_DOMAIN_SERVICE + "/lk/setting" })
            .then((res) => {
                if (res.data.Status === 1) {
                    setLinkVk('https://id.vk.com/authorize?response_type=code&client_id=53054071&scope=email%20phone&redirect_uri=https://biz-office.ru/auth/bind/vk&code_challenge=' + res.data.Data.Code_Challenge + '&code_challenge_method=S256&state=' + res.data.Data.ID);
                    setLinkYa('https://oauth.yandex.ru/authorize?response_type=code&client_id=08bc3cd18c56450aa52de54a825dbabb&redirect_uri=https://biz-office.ru/auth/bind/ya&code_challenge=' + res.data.Data.Code_Challenge + '&code_challenge_method=S256&state=' + res.data.Data.ID);
                }
            })
            .catch((err) => {
                ErrorAdd(err, window.location.href);
            });
    }, []);

    useEffect(() => {
        if (timeZoneList != null & stateSetting.userParameter.filter(a => a.ID_Parameter === 7).length > 0) {
            setTimeZoneSelected({ ...timeZoneList.filter(a => a.value === stateSetting.userParameter.filter(a => a.ID_Parameter === 7)[0].Value_Float)[0] })
        }

        if (stateSetting.user !== null) {
            setName(stateSetting.user.Name);
            setEmail(stateSetting.user.Email);
            setPhone(stateSetting.user.Phone);

            if (stateSetting.user.Avatar_Small !== null) {
                setAvatar(stateSetting.user.Avatar_Original);
            }
        }

    }, [stateSetting.user, timeZoneList, stateSetting.userParameter]);

    //Внешние поставщики авторизации
    function loadAuthExternalList() {
        axios.get('/api_main/user/authExternalList').then((res) => {
            if (res.data.Status === 1) {
                dispatch(loadAuthExternal({ data: res.data.Data }));
            }
        })
            .catch((err) => {
                ErrorAdd(err, window.location.href);
            });
    }

    const [hideName, setHideName] = useState(false);
    const [logName, setLogName] = useState(null);
    const [loadingName, setLoadingName] = useState(false);

    //Изменит имя
    function handlerChangeName(text) {
        setLoadingName(true);
        setLogName(null);

        axios.post('/api_main/user/nameSet', { Name: text })
            .then((res) => {
                if (res.data.Status === 1) {
                    setLoadingName(false);
                    setHideName(true);
                }
                else {
                    setLogName(res.data.Error);
                    setLoadingName(false);
                }
            })
            .catch((err) => {
                setLogName('Неизвестная ошибка!');
                setLoadingName(false);
                ErrorAdd(err, window.location.href);
            });
    }

    //Изменит часовой пояс
    function handlerChangeTimeZone(e) {
        setTimeZoneLoading(true);

        axios.post('/api_main/user/parameterSet', { ID_Parameter: 7, Value_Float: e.value })
            .then((res) => {
                if (res.data.Status === 1) {
                    setTimeZoneLoading(false);
                    setTimeZoneSelected({ ...timeZoneList.filter(a => a.value === e.value)[0] });
                }
            })
            .catch((err) => {
                setTimeZoneLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }

    //МОДАЛЬНЫЕ ОКНА
    const [modalContactConfirmShow, setModalContactShow] = useState(false);
    const [modalPasswordChangeShow, setPasswordChangeShow] = useState(false);
    const [modalAuthRemoveShow, setModalAuthRemoveShow] = useState(false);
    const [modalAvatar, setModalAvatar] = useState(false);

    const [authSelectIdType, setAuthSelectIdType] = useState(true);
    const [linkVk, setLinkVk] = useState('');
    const [linkYa, setLinkYa] = useState('');

    return (
        <>
            {modalContactConfirmShow === true && (<ModalEmailConfirm show={modalContactConfirmShow} onHide={() => setModalContactShow(false)} id_type={contactTypeSelected} />)}
            {modalPasswordChangeShow === true && (<ModalPasswordChange show={modalPasswordChangeShow} onHide={() => setPasswordChangeShow(false)} />)}
            {modalAuthRemoveShow === true && (<BlockProviderModalRemove show={modalAuthRemoveShow} onHide={() => setModalAuthRemoveShow(false)} id_type={authSelectIdType} update={loadAuthExternalList} />)}
            {modalAvatar === true && (<BlockMainAvatar show={modalAvatar} onHide={() => setModalAvatar(false)} />)}
            <div className="main-card mb-3 card p-4">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div className="setting_avatar" onClick={() => setModalAvatar(true)}>
                        <FontAwesomeIcon className="avatar_hover" icon={faCamera} />
                        <AvatarRound img={avatar} width={70} name={name.charAt(0)} />
                    </div>
                    <div style={{ marginLeft: '10px' }}>
                        <CardName name={name} onlyRead={false} placeholder='Имя...' updateHandler={handlerChangeName} hide={hideName} setHide={setHideName} />
                        {logName !== null && (<div className="form_error">{logName}</div>)}
                    </div>
                </div>
                {logFile !== null && (<div className="form_error">{logFile}</div>)}
                <div className="row mt-3">
                    <div className="col-lg-6">
                        <div className="mb-3">
                            <Form.Label>Электронная почта</Form.Label>
                            <InputGroup className="">
                                <Form.Control defaultValue={email} disabled />
                                {existEmail === false && (<Button variant="success" onClick={() => { setContactTypeSelected(1); setModalContactShow(true) }}><FontAwesomeIcon icon={faPlus} /></Button>)}
                            </InputGroup>
                            {existEmail === false && (<div className="form_error">Добавьте Email</div>)}
                        </div>
                        <div className="mb-3">
                            <Form.Label>Номер телефона</Form.Label>
                            <InputGroup className="">
                                <Form.Control defaultValue={phone} disabled />
                                {existPhone === false && (<Button variant="success" onClick={() => { setContactTypeSelected(2); setModalContactShow(true) }}><FontAwesomeIcon icon={faPlus} /></Button>)}
                            </InputGroup>
                            {existPhone === false && (<div className="form_error">Добавьте номер телефона</div>)}
                        </div>
                        <div >
                            <SelectSearchV2 key={timeZoneSelected} name="Часовой пояс" options={timeZoneList} defaultValue={timeZoneSelected} onChange={(e) => handlerChangeTimeZone(e)} disabled={timeZoneLoading} />
                        </div>


                        <div className="row mt-15 mb-15">
                            <div className="col-12"><div className="info_btn"><ButtonLight icon={faKey} text='Изменить пароль' onClick={() => setPasswordChangeShow(true)} /></div></div>
                        </div>


                        <div className="mt-20 text-center">
                            {stateSetting.authExternal.map(item => (
                                <div key={item.ID} >
                                    {
                                        item.Added === true ? (
                                            <div className="social_block ">
                                                <a className='btn social_btn disabled_' href={""} onClick={(e) => { e.preventDefault(); setAuthSelectIdType(item.ID); setModalAuthRemoveShow(true) }}>
                                                    {item.ID === 1 && <img className="social_img" src={logo_vk}></img>}
                                                    {item.ID === 2 && <img className="social_img" src={logo_ya}></img>}
                                                    <i className="fas fa-lg mr-10 text-success"><FontAwesomeIcon icon={faCheck} /></i>
                                                    {item.Name}  (ПОДКЛЮЧЕНО)
                                                </a>
                                            </div>
                                        ) : (
                                            <div className="social_block ">
                                                <a className='btn social_btn' href={item.ID === 1 ? linkVk : linkYa}>
                                                    {item.ID === 1 && <img className="social_img" src={logo_vk}></img>}
                                                    {item.ID === 2 && <img className="social_img" src={logo_ya}></img>}
                                                    Подключить {item.Name}
                                                </a>
                                            </div>
                                        )
                                    }
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-6">
                        {stateSetting.user !== null && stateSetting.user.Is_Password === false && (
                            <div className="info_danger mt-20">Не задан пароль! Для того чтобы не потерять доступ к сервесу необходимо задать пароль для учетной записи.
                                <div className="row mt-15 mb-15">
                                    <div className="col-12 text-center"><div className="info_btn"><ButtonLight icon={faPlus} text='Добавить пароль' onClick={() => setPasswordChangeShow(true)} /></div></div>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </>
    )
}
export default BlockMain;